import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractInputSelect } from '@components/field_form/select-inputs/abstract-input-select';
import { AbstractService } from '@services/Abstract.service';
import { AccountService } from '@services/cms/account.service';

@Component({
  selector: 'app-input-select-account',
  templateUrl: './input-select-account.component.html',
  styleUrls: ['./input-select-account.component.scss']
})
export class InputSelectAccountComponent extends AbstractInputSelect implements OnInit {
  @Input() public serviceModel: AbstractService | null = null;
  @Input() public label = 'account';
  @Input() public name = '';
  @Input() public required = false;
  @Input() public multiple = false;
  @Input() public disabled = false;
  reloadData = true;
  list: any[] = [];
  selectTemporal: any[] = [];
  private isDataLoading = false;
  // Events
  @Output() changeAction = new EventEmitter<any>();
  @Output() loadAction = new EventEmitter<any>();

  constructor(
      public service: AccountService
  ) {
    super(service);
  }

  ngOnInit(): void {
    console.log(this.list);
    this.loadData('data');
  }

  public change = () => {
    this.changeAction.emit();
  }
}
